import { render, staticRenderFns } from "./TagWordCloud.vue?vue&type=template&id=9a73bb60&"
import script from "./TagWordCloud.vue?vue&type=script&lang=ts&"
export * from "./TagWordCloud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports